import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import Table from './components/Table'

import Counter from '../../../../../../../../../../../components/Counter'

import { LOCALE_PREFIX } from '../../constants'

import './style.scss'

export default class Share extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        summaryData: PropTypes.object,
    }

    render() {
        const { id, module, block, level, summaryData } = this.props

        return (
            <div className={'liens-share-container'}>
                <div className={'title-container'}>
                    <span className={'highlighted-title'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.shareTitle`} />
                    </span>
                    <FormattedMessage id={`${LOCALE_PREFIX}.czechRegister`} />
                </div>
                <div className={'summary-container'}>
                    <div className="row">
                        <div className="summary-block">
                            <Counter
                                leftValue={{
                                    value: _.get(summaryData, 'ownerShareCount', 0),
                                }}
                                description={
                                    <FormattedMessage id={`${LOCALE_PREFIX}.liensPerOwner`} values={{ br: <br /> }} />
                                }
                            />
                        </div>
                        <div className="summary-block">
                            <Counter
                                leftValue={{
                                    value: _.get(summaryData, 'businessShareCount', 0),
                                }}
                                description={
                                    <FormattedMessage
                                        id={`${LOCALE_PREFIX}.liensPerDaughter`}
                                        values={{ br: <br /> }}
                                    />
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="table-container">
                    <Table id={id} module={module} block={block} level={level} />
                </div>
            </div>
        )
    }
}
